import * as yup from 'yup';
import { MAX_DEFAULT_FIELD_SYMBOLS } from 'constants/general';
import { TStockFormValues } from './StockForm.types';

export const stockFormSchema: yup.ObjectSchema<TStockFormValues> = yup
  .object({
    name: yup
      .string()
      .required('Name is required')
      .max(
        MAX_DEFAULT_FIELD_SYMBOLS,
        `Name must not exceed ${MAX_DEFAULT_FIELD_SYMBOLS} characters`
      ),
    variation: yup
      .string()
      .default('')
      .defined()
      .max(
        MAX_DEFAULT_FIELD_SYMBOLS,
        `Variation must not exceed ${MAX_DEFAULT_FIELD_SYMBOLS} characters`
      ),
    quantity: yup
      .number()
      .required('Quantity is required')
      .integer('Quantity must be an integer')
      .min(0, 'Quantity must be greater than or equal to 0')
      .typeError('Quantity is required'),
    type: yup
      .mixed<TStockFormValues['type']>()
      .required('Type is required')
      .oneOf(['phoneCase']),
  })
  .required();
